export const getSelectionToClipboard = () => {
  if (document.getSelection) {
    document.getSelection().toString();
    document.execCommand('Copy');
  }
};
